export type ConfigDocument = Record<string, any>;

export const isExtendedCameraConfig = (camera: ConfigDocument = {}) =>
  ['RecordStartCheckTime', 'CameraResolution', 'CodecName', 'FileFramerate', 'FileResolution', 'Bitrate']
    .some((key) => Object.prototype.hasOwnProperty.call(camera, key));

export const applyTonometerPreset = (draft: ConfigDocument, type: string) => {
  draft.TonometerConfig ||= {};
  draft.TonometerConfig.TonometerType = type;
  if (type === '1') {
    draft.TonometerConfig.SerialPortName ||= '/dev/gemodin';
    draft.TonometerConfig.BaudRate ||= 9600;
  }
};

export const applyPrinterPreset = (draft: ConfigDocument, name: string) => {
  draft.PrinterConfig ||= {};
  draft.CustomPdfTemplateConfig ||= {};
  draft.PrinterConfig.PrinterName = name;
  if (name === 'HS-K23') {
    draft.PrinterConfig.PrintOptions = '-o SetPrintSpeed=50 -o SetPrintDensity=15';
    draft.CustomPdfTemplateConfig.PageWidth = '48';
    draft.CustomPdfTemplateConfig.PageHeight = '25';
  } else {
    delete draft.PrinterConfig.PrintOptions;
    draft.CustomPdfTemplateConfig.PageWidth = '58';
    draft.CustomPdfTemplateConfig.PageHeight = '28';
  }
};

export const applyCameraFormat = (draft: ConfigDocument, format: 'legacy' | 'extended') => {
  const current = draft.CameraConfig || {};
  if (format === 'legacy') {
    draft.CameraConfig = {
      CameraType: current.CameraType || 'Rpi', CameraName: current.CameraName ?? '', FilesPath: current.FilesPath || 'Videos',
      MaxRecordingSeconds: current.MaxRecordingSeconds || 240, MockDevice: Boolean(current.MockDevice),
    };
    delete draft.SideCameraConfig;
    return;
  }
  draft.CameraConfig = extendedDefaults(current, null);
  draft.SideCameraConfig = extendedDefaults(draft.SideCameraConfig || {}, '/dev/fhd-camera');
};

export const setConfigPath = (draft: ConfigDocument, section: string, key: string, value: unknown) => {
  draft[section] ||= {};
  draft[section][key] = value;
};

function extendedDefaults(current: ConfigDocument, defaultName: string | null) {
  return { ...current, CameraType: current.CameraType || 'Rpi', CameraName: current.CameraName ?? defaultName,
    FilesPath: current.FilesPath || 'Videos', MaxRecordingSeconds: current.MaxRecordingSeconds || 240,
    RecordStartCheckTime: current.RecordStartCheckTime || 20, CameraFramerate: current.CameraFramerate || '30',
    CameraResolution: current.CameraResolution || '1280x720', CodecName: current.CodecName || 'libx264',
    FileFramerate: current.FileFramerate || '5', FileResolution: current.FileResolution || '1280x720',
    Bitrate: current.Bitrate || '250k', MockDevice: Boolean(current.MockDevice), IsDisabled: Boolean(current.IsDisabled) };
}
